module.exports = __webpack_public_path__ + "270844a95a3b87e6dbb5ecda0338a0ed.woff2";